<!--  -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">流水号</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.RecordCode" placeholder="流水号"></el-input>
                <div class="search-name">供应商</div>
                <el-select
                    class="search-item"
                    size="small"
                    v-model="searchData.CName"
                    remote
                    filterable
                    allow-create
                    placeholder="供应商名称"
                    :remote-method="searchSupplier"
                    v-select-scroll-more="searchSupplierLoad"
                >
                    <el-option v-for="item in supplierOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName"> </el-option>
                </el-select>
                <div class="search-name">单据号</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.OrderCode" placeholder="采购单号/采购售后单号"></el-input>
                <div class="search-name">款项类型</div>
                <el-select class="search-item" size="small" multiple collapse-tags style="width: 180px" v-model="searchData.PRType">
                    <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                </el-select>
                <div class="search-name">确认状态</div>
                <el-select class="search-item" size="small" v-model="searchData.IsConfirm">
                    <el-option v-for="item in confirmStateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                </el-select>
                <div class="search-name">支付方式</div>
                <el-select class="search-item" size="small" v-model="searchData.PayType">
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                </el-select>
                <div class="search-name">申请日期</div>
                <i class="el-icon-date search-name time-btn" @click="timeVisible = true"></i>
                <div class="search-name">确认日期</div>
                <i class="el-icon-date search-name time-btn" @click="timeConfirmVisible = true"></i>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                <el-button size="small" icon="el-icon-s-data" class="search-btn btn-primary" @click="showCount">合计</el-button>
            </div>
        </div>
        <!-- <div>
        <el-card class="box-card">
          <div class="data-count"> <div class="data-item">
              <p>采购总额</p>
              <p>{{ statData.returnCount }}</p>
            </div>
            <div class="data-item">
              <p>采购退款总额</p>
              <p>￥{{ statData.refundTotal }}</p>
            </div>
            <div class="data-item">
              <p>预付款总额</p>
              <p>￥{{ statData.saleTotal }}</p>
            </div>
            <div class="data-item">
              <p>未结算总额</p>
              <p style="color: red; font-size: 16px">
                ￥{{ statData.returnTotal }}
              </p>
            </div>
            <div  class="data-item border-right-none">
              <p>当前结余款总额</p>
              <p style="color: red; font-size: 16px">
                ￥{{ statData.surplusTotal }}
              </p>
            </div>
          </div>
        </el-card>
      </div> -->
        <div class="table-ctn interact-order-table">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                border
                :data="tableData"
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                style="width: 100%"
                :expand-row-keys="expandRow"
                :tableCode="tableCode"
                :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
                :cell-class-name="cellClassName"
                :row-key="getRowKeys"
            >
                <el-table-column type="selection" reserve-selection width="50"></el-table-column>
                <el-table-column
                    prop="RecordCode"
                    sortable
                    v-if="columnShowSets.RecordCode.IsShow"
                    :width="columnShowSets.RecordCode.Width > 0 ? columnShowSets.RecordCode.Width + 'px' : '230px'"
                    :label="columnShowSets.RecordCode.ColumnName"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <el-badge value="已结算" class="mark" type="danger" v-if="scope.row.IsSettle">
                            {{ scope.row.RecordCode }}
                        </el-badge>
                        {{ scope.row.IsSettle ? '' : scope.row.RecordCode }}
                    </template></el-table-column
                >
                <el-table-column
                    prop="PRTypeName"
                    v-if="columnShowSets.PRTypeName.IsShow"
                    :width="columnShowSets.PRTypeName.Width > 0 ? columnShowSets.PRTypeName.Width + 'px' : '120px'"
                    :label="columnShowSets.PRTypeName.ColumnName"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    prop="OrderCode"
                    v-if="columnShowSets.OrderCode.IsShow"
                    :width="columnShowSets.OrderCode.Width > 0 ? columnShowSets.OrderCode.Width + 'px' : '180px'"
                    :label="columnShowSets.OrderCode.ColumnName"
                    sortable
                    show-overflow-tooltip
                    ><template slot-scope="scope">
                        <el-button v-if="scope.row.PRType == 1" style="color: orange" @click="gotoReturnDetails(scope.row.OrderId)" type="text">
                            {{ scope.row.OrderCode }}
                        </el-button>
                        <el-button v-else-if="scope.row.PRType == 2" @click="gotoOrderDetails(scope.row.OrderId)" type="text">
                            {{ scope.row.OrderCode }}
                        </el-button>
                        <div v-else>{{ scope.row.OrderCode }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="CName"
                    v-if="columnShowSets.CName.IsShow"
                    :width="columnShowSets.CName.Width > 0 ? columnShowSets.CName.Width + 'px' : '160px'"
                    :label="columnShowSets.CName.ColumnName"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    prop="PayTypeName"
                    v-if="columnShowSets.PayTypeName.IsShow"
                    :width="columnShowSets.PayTypeName.Width > 0 ? columnShowSets.PayTypeName.Width + 'px' : '100px'"
                    :label="columnShowSets.PayTypeName.ColumnName"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    prop="SumPayable"
                    v-if="columnShowSets.SumPayable.IsShow"
                    :width="columnShowSets.SumPayable.Width > 0 ? columnShowSets.SumPayable.Width + 'px' : '140px'"
                    :label="columnShowSets.SumPayable.ColumnName"
                    sortable
                    show-overflow-tooltip
                    ><template slot-scope="scope">
                        <el-tag v-if="scope.row.PRType == 1 && scope.row.SumPayable != 0" class="t-tag" size="mini" type="success" effect="plain">应收</el-tag>
                        <el-tag v-if="scope.row.PRType == 2 && scope.row.SumPayable != 0" class="t-tag" size="mini" type="danger" effect="plain">应付</el-tag>
                        <el-tag v-if="scope.row.PRType == 8 || scope.row.PRType == 9" class="t-tag" size="mini" type="warning" effect="plain">结余</el-tag
                        >{{ scope.row.PRType == 5 ? '-' : scope.row.SumPayable }}</template
                    ></el-table-column
                >
                <el-table-column
                    prop="AlreadyPaid"
                    sortable
                    v-if="columnShowSets.AlreadyPaid.IsShow"
                    :width="columnShowSets.AlreadyPaid.Width > 0 ? columnShowSets.AlreadyPaid.Width + 'px' : '120px'"
                    :label="columnShowSets.AlreadyPaid.ColumnName"
                    show-overflow-tooltip
                    ><template slot-scope="scope">{{
                        scope.row.PRType == 5 ? (scope.row.IsSettle ? scope.row.AlreadyPaid : '-') : scope.row.AlreadyPaid
                    }}</template></el-table-column
                >
                <el-table-column
                    prop="NowPayNumber"
                    sortable
                    v-if="columnShowSets.NowPay.IsShow"
                    :width="columnShowSets.NowPay.Width > 0 ? columnShowSets.NowPay.Width + 'px' : '120px'"
                    :label="columnShowSets.NowPay.ColumnName"
                    show-overflow-tooltip
                    ><template slot-scope="scope">{{ scope.row.NowPayNumber }}</template></el-table-column
                >
                <el-table-column
                    prop="Balance"
                    sortable
                    v-if="columnShowSets.Balance.IsShow"
                    :width="columnShowSets.Balance.Width > 0 ? columnShowSets.Balance.Width + 'px' : '100px'"
                    :label="columnShowSets.Balance.ColumnName"
                    show-overflow-tooltip
                    ><template slot-scope="scope">{{ scope.row.Balance }}</template></el-table-column
                >
                <el-table-column
                    prop="Discount"
                    sortable
                    v-if="columnShowSets.Discount.IsShow"
                    :width="columnShowSets.Discount.Width > 0 ? columnShowSets.Discount.Width + 'px' : '100px'"
                    :label="columnShowSets.Discount.ColumnName"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">{{ scope.row.Discount }}</template></el-table-column
                >
                <el-table-column
                    prop="Remark"
                    v-if="columnShowSets.Remark.IsShow"
                    :width="columnShowSets.Remark.Width > 0 ? columnShowSets.Remark.Width + 'px' : '200px'"
                    :label="columnShowSets.Remark.ColumnName"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    prop="Operator"
                    v-if="columnShowSets.Operator.IsShow"
                    :width="columnShowSets.Operator.Width > 0 ? columnShowSets.Operator.Width + 'px' : '80px'"
                    :label="columnShowSets.Operator.ColumnName"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    prop="CreateTime"
                    sortable
                    v-if="columnShowSets.CreateTime.IsShow"
                    :width="columnShowSets.CreateTime.Width > 0 ? columnShowSets.CreateTime.Width + 'px' : '160px'"
                    :label="columnShowSets.CreateTime.ColumnName"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    v-if="columnShowSets.ConfirmTime.IsShow"
                    :width="columnShowSets.ConfirmTime.Width > 0 ? columnShowSets.ConfirmTime.Width + 'px' : '160px'"
                    :label="columnShowSets.ConfirmTime.ColumnName"
                    prop="ConfirmTime"
                    sortable
                    show-overflow-tooltip
                >
                    <template slot="header">
                        {{ columnShowSets.ConfirmTime.ColumnName }}
                    </template>
                    <template slot-scope="scope">
                        {{ scope.row.ConfirmTime == '1900-01-01 00:00:00' || !scope.row.IsConfirm ? '-' : scope.row.ConfirmTime }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="PayTime"
                    sortable
                    v-if="columnShowSets.PayTime.IsShow"
                    :width="columnShowSets.PayTime.Width > 0 ? columnShowSets.PayTime.Width + 'px' : '120px'"
                    :label="columnShowSets.PayTime.ColumnName"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        {{ scope.row.PayTime == '1900-01-01 00:00:00' ? '-' : scope.row.PayTime == scope.row.CreateTime ? '-' : scope.row.PayTime.substring(0, 10) }}
                    </template></el-table-column
                >
                <el-table-column fixed="right" label="操作" :autoWidth="true" :isCanSet="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button
                                v-if="permission.confirmApply && !scope.row.IsConfirm"
                                :title="permission.confirmApply"
                                size="mini"
                                type="text"
                                :style="scope.row.PRType == 3 ? btnOrStyle : ''"
                                @click="confirmApply(scope.row.RecordId)"
                                >{{ scope.row.PRType == 2 || scope.row.PRType == 5 || (scope.row.PRType == 9 && !(scope.row.SumPayable > 0)) ? '确认付款' : '确认收款' }}</el-button
                            >
                            <el-button
                                v-if="permission.cancelApply && !scope.row.IsConfirm"
                                :title="permission.cancelApply"
                                size="mini"
                                type="text"
                                style="color: red"
                                @click="cancelApply(scope.row.RecordId)"
                                >{{ permission.cancelApply }}</el-button
                            >
                            <el-button v-if="scope.row.IsConfirm && scope.row.PRType != 8" size="mini" type="text" disabled>{{
                                scope.row.PRType == 2 || scope.row.PRType == 5 || (scope.row.PRType == 9 && !(scope.row.SumPayable > 0)) ? '已确认付款' : '已确认收款'
                            }}</el-button>
                            <el-button
                                v-if="
                                    permission.settleUp &&
                                    scope.row.PRType == 8 &&
                                    scope.row.SumPayable + scope.row.ShipMoney - scope.row.AlreadyPaid - scope.row.NowPay != 0 &&
                                    !scope.row.IsSettle
                                "
                                :title="permission.settleUp"
                                size="mini"
                                type="text"
                                :style="scope.row.SumPayable > 0 ? '' : btnOrStyle2"
                                @click="settleUp(scope.row)"
                                >{{ scope.row.SumPayable > 0 ? '核算收款' : '核算付款' }}</el-button
                            >
                            <el-button
                                v-if="
                                    permission.settleUpNeedConfirm &&
                                    scope.row.PRType == 8 &&
                                    scope.row.SumPayable + scope.row.ShipMoney - scope.row.AlreadyPaid - scope.row.NowPay != 0 &&
                                    !scope.row.IsSettle
                                "
                                :title="permission.settleUpNeedConfirm"
                                size="mini"
                                type="text"
                                @click="settleUpNeedConfirm(scope.row.RecordId, scope.row.SumPayable, scope.row.CName, scope.row.AlreadyPaid)"
                                >{{ scope.row.SumPayable > 0 ? '申请核收' : '申请核付' }}</el-button
                            >
                            <el-button
                                v-if="permission.backState && scope.row.IsCanBack && scope.row.PRType != 8 && scope.row.IsConfirm"
                                size="mini"
                                type="text"
                                style="color: red"
                                @click="backState(scope.row.RecordId)"
                                >{{ permission.backState }}</el-button
                            >
                            <el-button
                                v-if="permission.backState && scope.row.IsSettle && scope.row.IsConfirm && scope.row.PRType == 8"
                                size="mini"
                                type="text"
                                style="color: red"
                                @click="backState(scope.row.RecordId)"
                                >{{ permission.backState }}</el-button
                            >
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" title="合计" @close="closeDialog" :visible.sync="statisticsVisible" width="500px">
            <div class="dialog-content" v-if="statisticsVisible">
                <statistics :countData="multipleSelection" type="flow_sup"></statistics>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="申请时间" :visible.sync="timeVisible" width="800px">
            <div class="dialog-content" v-if="timeVisible">
                <timePicker @timerSearch="timerSearch" :start="this.searchData.StartDate" :end="this.searchData.EndDate"></timePicker>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="确认时间" :visible.sync="timeConfirmVisible" width="800px">
            <div class="dialog-content" v-if="timeConfirmVisible">
                <timePicker @timerSearch="timerConfirmSearch" :start="this.searchData.StartConfirmDate" :end="this.searchData.EndConfirmDate"></timePicker>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :title="'【' + EntpCusName + '】核算结款'" :visible.sync="dialogSettleUpVisible" width="1200px">
            <div class="dialog-content" v-if="dialogSettleUpVisible">
                <settleUp ref="settleUp" @closeSettleUp="closeSettleUp" :RecordId="RecordId" :Amount="Amount" :Type="1" :Paid="Paid"></settleUp>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :title="'【' + EntpCusName + '】核算结款'" :visible.sync="dialogNewSettleUpVisible" width="1200px">
            <div class="dialog-content" v-if="dialogNewSettleUpVisible">
                <settleUpNeedConfirm ref="settleUpNeedConfirm" @closeSettleUp="closeSettleUp" :RecordId="RecordId" :Amount="Amount" :Type="1" :Paid="Paid"></settleUpNeedConfirm>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import statistics from '@/components/common/statistics.vue';
import timePicker from '@/components/common/timePicker';
import settleUp from '@/components/business/revenue/settleUp';
import settleUpNeedConfirm from '@/components/business/revenue/settleUpNeedConfirm';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [pageLimitMixin],
    name: '',
    components: {
        statistics,
        timePicker,
        breadcrumb,
        elTableColumn,
        settleUp,
        settleUpNeedConfirm
    },
    props: ['type'],
    data() {
        return {
            tableCode: 'SupInteractTable',
            timeVisible: false,
            timeConfirmVisible: false,
            statisticsVisible: false,
            multipleSelection: [],
            dialogSettleUpVisible: false,
            dialogNewSettleUpVisible: false,
            btnOrStyle: 'color:orange',
            btnOrStyle2: 'color:red',
            RecordId: '',
            EntpCusName: '',
            Amount: 0,
            Paid: 0,
            searchData: {
                RecordCode: '',
                PayType: '',
                CName: '',
                OrderCode: '',
                PRType: [],
                IsConfirm: '3',
                StartDate: '',
                EndDate: '',
                StartConfirmDate: '',
                EndConfirmDate: '',
                page: 1,
                limit: 15
            },
            statData: {
                returnTotal: 0,
                saleTotal: 0,
                refundTotal: 0,
                returnCount: 0,
                surplusTotal: 0
            },
            tableData: [],
            tableDataLength: 0,
            permission: {},
            stateList: [
                { Text: '供应商预付款', Value: '5' },
                { Text: '采购付款', Value: '2' },
                { Text: '采购退货收款', Value: '1' }
                // { Text: "结余款项", Value: "8" },
                // { Text: "结余申请款项", Value: "9" },
            ],
            confirmStateList: [
                { Text: '全部', Value: '-1' },
                { Text: '未结算', Value: '3' },
                { Text: '未确认', Value: '0' },
                { Text: '已确认', Value: '1' },
                { Text: '已结算', Value: '2' }
            ],
            payWayList: [],
            expandRow: [],
            columnShowSets: {
                RecordCode: { ColumnName: '', IsShow: false, Width: 0 },
                PRTypeName: { ColumnName: '', IsShow: false, Width: 0 },
                OrderCode: { ColumnName: '', IsShow: false, Width: 0 },
                CName: { ColumnName: '', IsShow: false, Width: 0 },
                PayTypeName: { ColumnName: '', IsShow: false, Width: 0 },
                SumPayable: { ColumnName: '', IsShow: false, Width: 0 },
                AlreadyPaid: { ColumnName: '', IsShow: false, Width: 0 },
                NowPay: { ColumnName: '', IsShow: false, Width: 0 },
                Balance: { ColumnName: '', IsShow: false, Width: 0 },
                Discount: { ColumnName: '', IsShow: false, Width: 0 },
                Remark: { ColumnName: '', IsShow: false, Width: 0 },
                Operator: { ColumnName: '', IsShow: false, Width: 0 },
                ConfirmTime: { ColumnName: '', IsShow: false, Width: 0 },
                CreateTime: { ColumnName: '', IsShow: false, Width: 0 },
                PayTime: { ColumnName: '', IsShow: false, Width: 0 }
            },
            // 用于供应商列表，分页搜索
            supplierOptions: [],
            supplierForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            }
        };
    },
    created() {
        if (this.tableCode) this.getSetsData();
    },
    mounted() {
        this.getTableData();
        this.searchSupplier();
        this.getPay();
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.permission = this.$util.getPermission('SupInteract');
    },
    watch: {
        NeedRefresh(value) {
            if (value.NeedRefresh) {
                this.getTableData();
            }
        }
    },
    computed: {
        NeedRefresh() {
            return this.$route.query;
        }
    },
    methods: {
        // 记录每行的key值
        getRowKeys(row) {
            return row.id;
        },
        // 供应商列表，搜索
        async searchSupplier(key) {
            if (![undefined].includes(key)) {
                this.supplierForm.Page = 1;
                this.supplierForm.stopLoad = false;
                this.supplierForm.key = key;
                this.supplierOptions = [];
            }
            if (this.supplierForm.stopLoad) return;
            const data = await this.$util.searchSupplier(this.supplierForm.key, this.supplierForm.Page, this.supplierForm.Limit);
            if (data) {
                if (!data) return;
                this.supplierForm.stopLoad = data.length < this.supplierForm.Limit;
                this.supplierOptions = [...this.supplierOptions, ...data];
            }
        },
        // 供应商列表，加载更多
        searchSupplierLoad() {
            this.supplierForm.Page += 1;
            this.searchSupplier();
        },
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
            });
        },
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.StartDate = timer.start;
            this.searchData.EndDate = timer.end;
            this.handleSearch();
        },
        timerConfirmSearch(timer) {
            this.timeConfirmVisible = false;
            this.searchData.StartConfirmDate = timer.start;
            this.searchData.EndConfirmDate = timer.end;
            this.handleSearch();
        },
        // 显示统计
        showCount() {
            if (this.multipleSelection) {
                this.statisticsVisible = true;
            } else {
                this.$util.warningMsg('请至少选择一条数据');
            }
        },
        closeDialog() {
            this.$refs.multipleTable.clearSelection();
            this.multipleSelection = null;
            this.statisticsVisible = false;
        },
        closeSettleUp(edit) {
            this.dialogSettleUpVisible = false;
            this.dialogNewSettleUpVisible = false;
            if (edit) this.getTableData();
        },
        // 勾选统计
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        resetSearch() {
            this.searchData = {
                RecordCode: '',
                PayType: '',
                CName: '',
                OrderCode: '',
                PRType: [],
                IsConfirm: '3',
                StartDate: '',
                EndDate: '',
                StartConfirmDate: '',
                EndConfirmDate: '',
                page: 1,
                limit: this.commonPageSize
            };
            this.searchSupplier('');
            this.$refs.multipleTable.clearSelection();
        },
        getTableData() {
            this.$util
                .axiosPost({
                    url: '/api/RevenueManagement/GetSupPaymentRecordsList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (data) {
                        data.forEach(item => {
                            item.NowPayNumber = item.PRType == 5 ? item.AlreadyPaid : item.NowPay;
                            item.Balance =
                                item.PRType == 8 && item.IsSettle
                                    ? 0
                                    : item.PRType == 5
                                    ? item.IsSettle
                                        ? 0
                                        : item.AlreadyPaid
                                    : (Math.abs(item.SumPayable) + item.ShipMoney - Math.abs(item.AlreadyPaid) - item.NowPay).toFixed(2) * 1;
                            item.Discount =
                                item.PRType == 8 && item.IsSettle ? (Math.abs(item.SumPayable) + item.ShipMoney - Math.abs(item.AlreadyPaid) - item.NowPay).toFixed(2) * 1 : 0;
                            if (item.PRType == 8 && !item.IsSettle) {
                                this.expandRow.push(item.id);
                            }
                        });
                        this.tableData = data;
                        this.tableDataLength = res.count;
                    } else {
                        this.tableData = [];
                        this.tableDataLength = 0;
                    }
                });
        },
        handleSearch() {
            this.$refs.multipleTable.clearSelection();
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        querySearch(queryString, cb) {
            this.$util.searchSupplier(queryString).then(data => {
                let customerList = [];
                for (let i in data) {
                    customerList.push({
                        value: data[i].EntpCusName
                    });
                }
                cb(customerList);
            });
        },
        confirmApply(id) {
            if (id) {
                this.$confirm('是否确认该条款项申请？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        this.loading = true;
                        this.$util
                            .axiosPost({
                                url: `/api/RevenueManagement/ConfirmApplyRecords?RecordId=${id}`
                            })
                            .then(res => {
                                this.$util.successMsg('确认款项成功');
                                this.getTableData();
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    })
                    .catch(() => {});
            } else {
                this.$util.warningMsg('请选择有效申请款项');
            }
        },
        cancelApply(id) {
            if (id) {
                this.$confirm('是否要撤销该条款项申请，撤销后将无法恢复？', '提示', {
                    confirmButtonText: '确定撤销',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        this.loading = true;
                        this.$util
                            .axiosPost({
                                url: `/api/RevenueManagement/CancelApplyRecords?RecordId=${id}`
                            })
                            .then(res => {
                                this.$util.successMsg('撤销申请成功');
                                this.getTableData();
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    })
                    .catch(() => {});
            } else {
                this.$util.warningMsg('请选择撤销有效申请款项');
            }
        },
        backState(id) {
            if (id) {
                this.$confirm('是否回退该条款项的确认状态？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        this.loading = true;
                        this.$util
                            .axiosPost({
                                url: `/api/RevenueManagement/BackRecordStates?RecordId=${id}`
                            })
                            .then(res => {
                                this.$util.successMsg('回退状态成功');
                                this.getTableData();
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    })
                    .catch(() => {});
            } else {
                this.$util.warningMsg('请选择有效申请款项');
            }
        },
        gotoReturnDetails(id) {
            this.$router.push(`/financeManage/purchasesReturns/gathering/confirmPurchasesRefunds?action=see&PReturnId=${id}`);
        },
        gotoOrderDetails(id) {
            this.$router.push(`/financeManage/purchasesOrder/payment/confirmPayment?action=see&id=${id}`);
        },
        settleUp(item) {
            if (item) {
                this.dialogSettleUpVisible = true;
                this.RecordId = item.RecordId;
                this.Amount = item.SumPayable;
                this.EntpCusName = item.CName;
                this.Paid = item.AlreadyPaid;
            } else {
                this.$util.warningMsg('需要结款的往来数据异常，请刷新后重试');
            }
        },
        settleUpNeedConfirm(id, amount, name, paid) {
            if (id) {
                this.dialogNewSettleUpVisible = true;
                this.RecordId = id;
                this.Amount = amount;
                this.EntpCusName = name;
                this.Paid = paid;
            } else {
                this.$util.warningMsg('需要结款的往来数据异常，请刷新后重试');
            }
        },
        getSetsData() {
            this.$util.getTableSetsData(this.tableCode, true).then(data => {
                data.forEach(item => {
                    switch (item.ColumnCode) {
                        case 'RecordCode':
                            this.columnShowSets.RecordCode.IsShow = item.IsShow;
                            this.columnShowSets.RecordCode.Width = item.Width;
                            this.columnShowSets.RecordCode.ColumnName = item.ColumnName;
                            break;
                        case 'PRTypeName':
                            this.columnShowSets.PRTypeName.IsShow = item.IsShow;
                            this.columnShowSets.PRTypeName.Width = item.Width;
                            this.columnShowSets.PRTypeName.ColumnName = item.ColumnName;
                            break;
                        case 'OrderCode':
                            this.columnShowSets.OrderCode.IsShow = item.IsShow;
                            this.columnShowSets.OrderCode.Width = item.Width;
                            this.columnShowSets.OrderCode.ColumnName = item.ColumnName;
                            break;
                        case 'CName':
                            this.columnShowSets.CName.IsShow = item.IsShow;
                            this.columnShowSets.CName.Width = item.Width;
                            this.columnShowSets.CName.ColumnName = item.ColumnName;
                            break;
                        case 'PayTypeName':
                            this.columnShowSets.PayTypeName.IsShow = item.IsShow;
                            this.columnShowSets.PayTypeName.Width = item.Width;
                            this.columnShowSets.PayTypeName.ColumnName = item.ColumnName;
                            break;
                        case 'SumPayable':
                            this.columnShowSets.SumPayable.IsShow = item.IsShow;
                            this.columnShowSets.SumPayable.Width = item.Width;
                            this.columnShowSets.SumPayable.ColumnName = item.ColumnName;
                            break;
                        case 'AlreadyPaid':
                            this.columnShowSets.AlreadyPaid.IsShow = item.IsShow;
                            this.columnShowSets.AlreadyPaid.Width = item.Width;
                            this.columnShowSets.AlreadyPaid.ColumnName = item.ColumnName;
                            break;
                        case 'NowPay':
                            this.columnShowSets.NowPay.IsShow = item.IsShow;
                            this.columnShowSets.NowPay.Width = item.Width;
                            this.columnShowSets.NowPay.ColumnName = item.ColumnName;
                            break;
                        case 'Balance':
                            this.columnShowSets.Balance.IsShow = item.IsShow;
                            this.columnShowSets.Balance.Width = item.Width;
                            this.columnShowSets.Balance.ColumnName = item.ColumnName;
                            break;
                        case 'Discount':
                            this.columnShowSets.Discount.IsShow = item.IsShow;
                            this.columnShowSets.Discount.Width = item.Width;
                            this.columnShowSets.Discount.ColumnName = item.ColumnName;
                            break;
                        case 'ConfirmTime':
                            this.columnShowSets.ConfirmTime.IsShow = item.IsShow;
                            this.columnShowSets.ConfirmTime.Width = item.Width;
                            this.columnShowSets.ConfirmTime.ColumnName = item.ColumnName;
                            break;
                        case 'Remark':
                            this.columnShowSets.Remark.IsShow = item.IsShow;
                            this.columnShowSets.Remark.Width = item.Width;
                            this.columnShowSets.Remark.ColumnName = item.ColumnName;
                            break;
                        case 'Operator':
                            this.columnShowSets.Operator.IsShow = item.IsShow;
                            this.columnShowSets.Operator.Width = item.Width;
                            this.columnShowSets.Operator.ColumnName = item.ColumnName;
                            break;
                        case 'CreateTime':
                            this.columnShowSets.CreateTime.IsShow = item.IsShow;
                            this.columnShowSets.CreateTime.Width = item.Width;
                            this.columnShowSets.CreateTime.ColumnName = item.ColumnName;
                            break;
                        case 'PayTime':
                            this.columnShowSets.PayTime.IsShow = item.IsShow;
                            this.columnShowSets.PayTime.Width = item.Width;
                            this.columnShowSets.PayTime.ColumnName = item.ColumnName;
                            break;
                    }
                });
            });
        },
        cellClassName({ row, column, rowIndex, columnIndex }) {
            if (column.type == 'selection' && row.IsChild) return 'mycell';
        }
    }
};
</script>
<style lang="less" scoped>
.data-count {
    padding: 5px;
    display: flex;
    .data-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 20%;
        border-right: 1px solid @border4Color;
        > p:nth-child(1) {
            margin-bottom: 5px;
        }
    }
}
.cell {
    .el-button {
        padding: 5px;
    }
}
.t-tag {
    padding: 0 2px 0 2px;
    margin-right: 3px;
}
</style>
<style lang="less">
.interact-order-table {
    .el-table__row {
        td:nth-child(2) {
            .cell {
                overflow: visible;
            }
        }
    }
    .el-table th > .cell {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
}
.mycell {
    .el-checkbox {
        display: none;
    }
}
</style>
